// Root file of project for import third party libraries for whole project
import { createApp } from "vue";
import store from "./store";
import App from "./App.vue";
import Toaster from "@meforma/vue-toaster";
import VueFlatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import router from "./router";
import "./main.css";
import PrimeVue from "primevue/config";
import AutoComplete from "primevue/autocomplete";
import DropDown from "primevue/dropdown";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import "primevue/resources/themes/md-light-indigo/theme.css";
import "primevue/resources/primevue.min.css";
import "primeicons/primeicons.css";
import moment from "moment-timezone";
import MultiSelect from "primevue/multiselect";
import inputMask from './directives/inputMask';

const app = createApp(App);
  
moment.tz.setDefault("America/New_York");
app.use(store);
app.use(Toaster);
app.use(router);
app.use(PrimeVue, {
  locale: {
    aria: {
      firstPageLabel: "First page",
      prevPageLabel: "Previous page",
      nextPageLabel: "Next page",
      lastPageLabel: "Last page",
      pageLabel: "Page",
      rowsPerPageLabel: "Rows per page",
      jumpToPageDropdownLabel: "Jump to page",
      jumpToPageInputLabel: "Jump to page",
    },
  },
});
app.component("AutoComplete", AutoComplete);
app.component("MultiSelect", MultiSelect);
app.component("DropDown", DropDown);
app.component("DataTable", DataTable);
app.component("Column", Column);
app.directive('input-mask', inputMask);
//app.use(Vuelidate);
app.use(VueFlatPickr);
app.mount("#app");
